<template>
    
    <PageTitle title="Add Associate Namecard" :breadcrumb="[ { name: 'Manage Namecard', link: '/namecard/manage' }, { name: 'Add Associate Namecard' } ]"></PageTitle>
    <div class="page-body">
        <div class="container-xl">
            <div class="row row-cards">
                <div class="col-12">
                    <div class="card mb-3">
                        <div class="card-body mb-4">
                            <h4 class="card-title">Search Associate</h4>
                            <div class="mb-3 row">
                                <div class="col-md-4 mb-3">
                                    <SearchAgent/>
                                </div>
                                <div class="col-md-4">
                                    <button type="submit" class="btn btn-red ms-auto" style="margin-top: 3px;" @click="searchAssociate()">
                                        <i class="ti ti-search"></i>
                                    </button>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                    <div class="card mb-3" v-if="showDetails">
                        <div class="card-body mb-4">
                            <h4 class="card-title">Select Template</h4>
                            <div class="card-subtitle">Click the image to select template</div>
                            <div class="row namecard-template text-center">
                                <div class="col-lg-2 mb-3" v-for="(template, index) in templates" :key="index">
                                    <img ondragstart="return false;" :src="template.front_template" @click="setTemplate(template)" :data-id="template.id" 
                                    :class="[ template.id == form.template_id ? 'active': '' ]"/>
                                    <h2 class="text-muted">{{ template.name }}</h2>
                                </div>
                            </div>
                        </div>
                        <div class="card-body mb-4" v-if="form.template_id">
                            <h4 class="card-title">User Info</h4>
                            <div class="row">
                                <div class="col-lg-5 mb-3">

                                    <div class="mb-3">
                                        <button @click="importBtn" class="btn btn-red" ><i class="ti ti-cloud-upload"></i> <span>Upload Photo</span></button>
                                        <input class="form-control-file inputFile hide" id="inputFile" name="inputFile" type="file" @change="uploadPhoto" accept=".jpg,.jepg,.png">
                                    </div>

                                    <div class="mb-3">
                                        <div class="form-label">Initial Name</div>
                                        <label class="form-check form-switch">
                                            <input class="form-check-input" type="checkbox" @change="nameToggle" :checked="nameToggleLabel">
                                            <span class="form-check-label">{{nameToggleLabel ? "Show" : "Hide"}}</span>
                                        </label>
                                    </div>

                                    <div class="mb-3">
                                        <div class="form-label">Name (Chinese)</div>
                                        <input type="text" class="form-control" v-model="namecn">
                                    </div>

                                    <div class="mb-3">
                                        <div class="form-label">Rank Name (Chinese)</div>
                                        <label class="form-check form-switch">
                                            <input class="form-check-input" type="checkbox" @change="rankToggle">
                                            <span class="form-check-label">{{ranknamecnToggle ? "Show" : "Hide"}}</span>
                                        </label>
                                    </div>

                                    <div class="mb-3">
                                        <div class="form-label">Photo</div>
                                        <label class="form-check form-switch">
                                            <input class="form-check-input" type="checkbox" @change="photoToggle" :checked="photoToggleLabel">
                                            <span class="form-check-label">{{photoToggleLabel ? "Show" : "Hide"}}</span>
                                        </label>
                                    </div>

                                    <div class="mb-3">
                                        <label class="form-label">Email</label>
                                        <input type="email" class="form-control" v-model="email" :class="{ 'is-invalid': error.email}">
                                        <div class="invalid-feedback">{{ error.email }}</div>
                                    </div>

                                    <div class="mb-3">
                                        <label class="form-label">Cert-In-CES</label>
                                        <input type="text" class="form-control mb-1" v-model="info.certInCes" maxlength="30">
                                        <input type="text" class="form-control" v-model="info.certInCes2" maxlength="30">
                                    </div>

                                    <div class="mb-3">
                                        <label class="form-label">Social Media Accounts</label>

                                        <div class="form-group row mb-3">
                                            <div class="col-md-3 col-form-label">Website</div>
                                            <div class="col-md-9">
                                                <input type="text" class="form-control" v-model="social.web" maxlength="30">
                                            </div>
                                        </div>

                                        <div class="form-group row mb-3">
                                            <div class="col-md-3 col-form-label">Facebook</div>
                                            <div class="col-md-9">
                                                <input type="text" class="form-control" v-model="social.fb" maxlength="30">
                                            </div>
                                        </div>

                                        <div class="form-group row mb-3">
                                            <div class="col-md-3 col-form-label">Instagram</div>
                                            <div class="col-md-9">
                                                <input type="text" class="form-control" v-model="social.ig" maxlength="30">
                                            </div>
                                        </div>

                                        <div class="form-group row mb-3">
                                            <div class="col-md-3 col-form-label">Tiktok</div>
                                            <div class="col-md-9">
                                                <input type="text" class="form-control" v-model="social.tiktok" maxlength="30">
                                            </div>
                                        </div>

                                    </div>

                                    <div class="mb-3">
                                        <label class="form-label">Order Quantity</label>
                                        <VueMultiselect selectLabel="" v-model="package_id" :options="packages" :multiple="false" group-values="packages" group-label="category" :group-select="false" placeholder="Type to search" track-by="name" label="name" :class="{ 'is-invalid': error.package_id}">
                                            <span>Oops! No elements found. Consider changing the search query.</span>
                                        </VueMultiselect>
                                        <div class="invalid-feedback">{{ error.package_id }}</div>
                                    </div>

                                    <div class="mb-4 mt-4">
                                        <label class="form-check">
                                            <input class="form-check-input" type="checkbox" v-model="form.require_payment" value="YES">
                                            <span class="form-label">Require Payment From Agent</span>
                                        </label>
                                    </div>

                                    <div class="mb-3" v-if="!form.require_payment">
                                        <label class="form-label">Remarks</label>
                                        <input type="text" class="form-control" v-model="form.remarks" :class="{ 'is-invalid': error.remarks}">
                                        <div class="invalid-feedback">{{ error.remarks }}</div>
                                    </div>

                                    <div class="mb-3" v-if="!form.require_payment">
                                        <label class="form-label">Payment Reference No.</label>
                                        <input type="text" class="form-control" v-model="form.payment_refno" :class="{ 'is-invalid': error.payment_refno}">
                                        <div class="invalid-feedback">{{ error.payment_refno }}</div>
                                    </div>

                                    <div class="mt-4">
                                        <div class="d-flex">
                                            <router-link :to="{ name: 'Namecard' }" class="btn btn-link">Cancel</router-link>
                                            <button type="submit" class="btn btn-success ms-auto" @click="submit" v-if="package_id">
                                                <span>Submit</span> 
                                                <i class="ti ti-chevron-right"></i>
                                            </button>
                                            <button type="submit" class="btn btn-success ms-auto" disabled="disabled" v-else>
                                                <span>Submit</span> 
                                                <i class="ti ti-chevron-right"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-7 overflow-auto">
                                    <CustomTa1 v-if="form.template.name == 'F1'"/>
                                    <CustomTa2 v-if="form.template.name == 'F2'"/>
                                    <CustomTa3 v-if="form.template.name == 'F3'"/>
                                    <CustomTa4 v-if="form.template.name == 'F4'"/>
                                    <CustomTa6 v-if="form.template.name == 'CUSTOM'"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>

</template>

<script>
import PageTitle from '../../components/PageTitle.vue';
import SearchAgent from '../../components/SearchAgent.vue';
import CustomTa1 from './components/CustomTa1.vue';
import CustomTa2 from './components/CustomTa2.vue';
import CustomTa3 from './components/CustomTa3.vue';
import CustomTa4 from './components/CustomTa4.vue';
import CustomTa6 from './components/CustomTa6.vue';
import { ref, onMounted, inject, getCurrentInstance } from 'vue';
import { useRouter } from "vue-router";
import { store } from '../../store.js';
import axios from 'axios';
import VueMultiselect from 'vue-multiselect';

export default {
    components: {
        PageTitle,
        CustomTa1,
        CustomTa2,
        CustomTa3,
        CustomTa4,
        CustomTa6,
        VueMultiselect,
        SearchAgent
    },
    setup() {
        const app = getCurrentInstance();
        const router = useRouter();
        const swal = inject('$swal');
        const form = ref([]);
        const social = ref({
            web: '',
            fb: '',
            ig: '',
            tiktok: ''
        });
        const templates = ref([]);
        const package_id = ref(false);
        const info = ref([]);
        const email = ref('');
        const showDetails = ref(false);
        const name = ref('');
        const namecn = ref('');
        const namenoInitial = ref('');
        const error = ref([]);
        const packages = ref([]);
        const asc_code = ref('');
        const associate = ref([]);
        const associates = ref([]);
        const loading = ref(false);
        const ranknamecnToggle = ref(false);
        const nameToggleLabel = ref(false);
        const photo = ref('');
        const photoToggleLabel = ref(true);

        async function getTemplates() {
            store.loading = true;
            await axios
            .get(process.env.VUE_APP_ENDPOINT+'/namecard/templates?custom=true',{
                params: {
                    user_type: 'ASSOC'
                }
            })
            .then(function (res) {
                store.loading = false;
                templates.value = res.data.namecards;
            })
            .catch(function (error) {
                store.loading = false;
                if (error.response && error.response.status == 401) {
                    router.push({ name: 'Logout' });
                } else if (error.response && error.response.status == 422) {
                    swal({
                        icon: 'error',
                        text: error.response.data.message,
                        showCloseButton: true,
                        showConfirmButton: false
                    });
                } else {
                    swal({
                        icon: 'error',
                        text: app.appContext.config.globalProperties.$error500,
                        showCloseButton: true,
                        showConfirmButton: false
                    });
                }
            });
        }

        async function getPackages() {
            store.loading = true;
            await axios
            .get(process.env.VUE_APP_ENDPOINT+'/namecard/packages')
            .then(function (res) {
                store.loading = false;
                packages.value = res.data.packages;
            })
            .catch(function (error) {
                store.loading = false;
                if (error.response && error.response.status == 401) {
                    router.push({ name: 'Logout' });
                } else if (error.response && error.response.status == 422) {
                    swal({
                        icon: 'error',
                        text: error.response.data.message,
                        showCloseButton: true,
                        showConfirmButton: false
                    });
                } else {
                    swal({
                        icon: 'error',
                        text: app.appContext.config.globalProperties.$error500,
                        showCloseButton: true,
                        showConfirmButton: false
                    });
                }
            });
        }

        onMounted(() => {
            getTemplates();
            getPackages();
        });

        return { app, store, swal, router, form, templates, package_id, info, social, name, namecn, namenoInitial, email, error, packages,
            asc_code, associate, associates, showDetails, loading, ranknamecnToggle, nameToggleLabel, photoToggleLabel, photo
        }
    },
    methods: {
        async searchAssociate() {
            this.clear();
            this.error.form = false;
            this.showDetails = false;
            this.info = [];
            this.email = '';
            this.form.template_id = '';

            if (!store.associate) {
                return false;
            }

            if (this.error.form == false) {
                store.loading = true;
                let model = this;
                await axios
                .get(process.env.VUE_APP_ENDPOINT+'/namecard/associate',{
                    params: {
                        code: store.associate.code
                    }
                })
                .then(function (res) {
                    store.loading = false;
                    model.info = res.data.associate;
                    model.email = res.data.associate.email;
                    model.name = res.data.associate.name;
                    model.namenoInitial = res.data.associate.name_noinitial;
                    model.photo = res.data.associate.photo;
                    let namecard = JSON.parse(localStorage.getItem('namecard'));
                    if (namecard && namecard.photo) {
                        model.info.photo = namecard.photo;
                        model.info.photo_name = namecard.photo_name;
                    }
                    model.showDetails = true;
                })
                .catch(function (error) {
                    store.loading = false;
                    if (error.response && error.response.status == 401) {
                        model.router.push({ name: 'Logout' });
                    } else if (error.response && error.response.status == 422) {
                        model.swal({
                            icon: 'error',
                            text: error.response.data.message,
                            showCloseButton: true,
                            showConfirmButton: false
                        });
                    } else {
                        model.swal({
                            icon: 'error',
                            text: model.app.appContext.config.globalProperties.$error500,
                            showCloseButton: true,
                            showConfirmButton: false
                        });
                    }
                });
            }

        },
        setTemplate (template) {
            this.form.template_id = template.id;
            this.form.template = template;
            store.namecard.template = template;
            store.namecard.user = this.info;
            store.namecard.user.name = this.info.name_noinitial;
            store.namecard.social = this.social;
        },
        uploadPhoto() {
            var fileElement = document.getElementById('inputFile');
            this.info.photo = URL.createObjectURL(fileElement.files[0]);
        },
        importBtn() {
            document.getElementById('inputFile').click();
        },
        async importFile() {
            store.loading = true;
            this.showUploadBtn = false;
            let model = this;

            if(store.namecard.user.photo != '')
            {
                var formData = new FormData();
                var fileElement = document.getElementById('inputFile');

                if(fileElement.files.length == 0)
                {
                    formData.append("photo", store.namecard.user.profile_default_photo);
                } else {
                    formData.append("photo", fileElement.files[0]);
                }

                await axios
                .post(process.env.VUE_APP_ENDPOINT+'/namecard/photo',formData,{
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
                .then(function (res) {
                    store.loading = false;
                    store.namecard.user.photo = res.data.path;
                    store.namecard.user.photo_name = res.data.filename;
                    model.goSubmit();
                })
                .catch(function (error) {
                    store.loading = false;
                    if (error.response && error.response.status == 401) {
                        model.router.push({ name: 'Logout' });
                    } else if (error.response && error.response.status != 500) {
                        model.swal({
                            icon: 'error',
                            text: error.response.data.message,
                            showCloseButton: true,
                            showConfirmButton: false
                        });
                    } else {
                        model.swal({
                            icon: 'error',
                            text: model.app.appContext.config.globalProperties.$error500,
                            showCloseButton: true,
                            showConfirmButton: false
                        });
                    }
                });
            } else {
                store.loading = false;
                model.goSubmit();
            }
        },
        submit () {
            this.error.form = false;
            this.clear();

            if (!this.email) {
                this.error.form = true;
                this.error.email = 'Email is required';
            }

            if (!this.name) {
                this.error.form = true;
                this.error.name = 'Name is required';
            }

            if (!this.package_id) {
                this.error.form = true;
                this.error.package_id = 'Package is required';
            }

            if (!this.error.form) {
                this.importFile();
            }
        },
        async goSubmit() {
            store.loading = true;
            let model = this;
            await axios
            .post(process.env.VUE_APP_ENDPOINT+'/namecard/manage',{
                user_type: 'ASSOC',
                associate: store.associate.code,
                namecard_id: this.form.template_id,
                package_id: this.package_id.id,
                photo:  store.namecard.user.photo_name,
                email: this.email,
                name: store.namecard.user.name,
                name_cn: this.namecn,
                rank: this.info.position,
                rank_cn: store.namecard.user.ranknamecn,
                cea_cert: this.info.certInCes,
                cea_cert2: this.info.certInCes2,
                social: {
                    web: store.namecard.social.web,
                    fb: store.namecard.social.fb,
                    ig: store.namecard.social.ig,
                    tiktok: store.namecard.social.tiktok,
                },
                cea_regno: store.namecard.user.cea_regno,
                require_payment: this.form.require_payment,
                remarks: this.form.remarks,
                hide_initial:this.nameToggleLabel ? 'N' : 'Y',
                payment_refno: this.form.payment_refno,
            })
            .then(function (res) {
                store.loading = false;
                localStorage.removeItem('namecard');

                model.swal({
                    icon: 'success',
                    html: res.data.message,
                    showCloseButton: true,
                    showConfirmButton: false
                });
                model.router.push({ name: 'NamecardManage' });
            })
            .catch(function (error) {
                store.loading = false;
                if (error.response && error.response.status == 401) {
                    model.router.push({ name: 'Logout' });
                } else if (error.response && error.response.status == 422) {
                    model.swal({
                        icon: 'error',
                        text: error.response.data.message,
                        showCloseButton: true,
                        showConfirmButton: false
                    });
                } else {
                    model.swal({
                        icon: 'error',
                        text: model.app.appContext.config.globalProperties.$error500,
                        showCloseButton: true,
                        showConfirmButton: false
                    });
                }
            });
        },
        rankToggle() {
            this.ranknamecnToggle = !this.ranknamecnToggle;
            if(this.ranknamecnToggle)
            {
                store.namecard.user.ranknamecn = store.namecard.user.position_cn;
            } else {
                store.namecard.user.ranknamecn = '';
            }
        },
        nameToggle() {
            let model = this;
            model.nameToggleLabel = !model.nameToggleLabel;
            if(model.nameToggleLabel)
            {
                store.namecard.user.name = model.name;
            } else {
                store.namecard.user.name = model.namenoInitial;
            }
        },
        photoToggle() {
            let model = this;
            model.photoToggleLabel = !model.photoToggleLabel;
            if(model.photoToggleLabel)
            {
                store.namecard.user.photo = model.photo;
            } else {
                store.namecard.user.photo_name = '';
                store.namecard.user.photo = '';
            }
        },
        clear() {
            this.error = [];
        }
    },
    
    watch: {
        email () {
            if (!this.email) {
                this.error.form = true;
                this.error.email = 'Email required';
            } else {
                if (store.namecard.user) {
                    store.namecard.user.email = this.email;
                }
                this.error.form = false;
                this.error.email = '';
            }
        },
        package_id() {
            let model = this;
            this.packages.forEach(function(row) {
                if (row.id == model.package_id.id) {
                    store.pay.points = model.info.total_points;
                    store.pay.points_text = model.info.total_points_text;
                    store.pay.amount = row.amount;
                }
            });
        },
        namecn() {
            if(store.namecard.user)
            {
                store.namecard.user.namecn = this.namecn;
            }
        }
    }
}
</script>
<style src="@/assets/vue-multiselect.min.css"></style>
<style>
    .namecard-template img {
        width: 250px;
        border: 3px solid #EAECEE;
        cursor: pointer;
    }

    .namecard-template img:hover {
        border: 3px solid #981D10
    }

    .namecard-template img.active {
        border: 3px solid #981D10
    }

    .multiselect__option--group {
        font-weight: bold;
    }

    .multiselect__option--highlight {
        background:#FCEBEC;
        color:#D63F3E;
    }
</style>